import { Button, Chip, Group, Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useState } from 'react';
import { isEmpty } from 'remeda';
import { usePopulateTemplateChannels } from '../api';
import type { TemplateChannelConfig } from './channels';

type AddChannelModalProps = {
  templateId: string;
  channels: TemplateChannelConfig[];
  onClose: () => void;
};

export const AddChannelModal = ({ templateId, channels, onClose }: AddChannelModalProps) => {
  const { t } = useTranslation();
  const { populateTemplateChannels, isPopulateTemplateChannelsLoading } =
    usePopulateTemplateChannels();
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);

  const addChannels = () =>
    populateTemplateChannels({ templateId, channels: selectedChannels }, { onSuccess: onClose });

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        {t(i18nKeys.TEMPLATE.EMPTY_CHANNELS_DESCRIPTION)}
      </Text>
      <Chip.Group multiple value={selectedChannels} onChange={setSelectedChannels}>
        <Group justify="center">
          {channels.map(({ key, labelKey, Icon }) => (
            <Chip key={key} value={key}>
              <Group component="span" gap={6} wrap="nowrap">
                <Icon size={16} stroke={1.5} />
                {t(labelKey)}
              </Group>
            </Chip>
          ))}
        </Group>
      </Chip.Group>
      <Group justify="flex-end" mt="xs">
        <Button variant="default" onClick={onClose} disabled={isPopulateTemplateChannelsLoading}>
          {t(i18nKeys.CANCEL)}
        </Button>
        <Button
          onClick={addChannels}
          disabled={isEmpty(selectedChannels)}
          loading={isPopulateTemplateChannelsLoading}
        >
          {t(i18nKeys.TEMPLATE.CREATE_CHANNELS)}
        </Button>
      </Group>
    </Stack>
  );
};
